module.exports = __webpack_public_path__ + "static/img/page38.9b044cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page38.jpg
// module id = 0Dt3
// module chunks = 0